import { canUseDOM } from 'exenv';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import Video from 'react-jw-player';
import Cookies from 'js-cookie';
import Slug from '../slug/slug';
import AdTagGenerator from '../video_module/utils/video_module_ads';
import log from '../../../services/logger_service';

let scriptjs = false;
let ifvisible = false;

if (canUseDOM) {
  // eslint-disable-next-line global-require
  scriptjs = require('scriptjs');
  // eslint-disable-next-line global-require
  ifvisible = require('ifvisible.js');
}

export default class VideoReactJW extends Component {
  constructor() {
    super();
    this.generatePreRoll = this.generatePreRoll.bind(this);
    this.setMoatTracking = this.setMoatTracking.bind(this);
    this.onReady = this.onReady.bind(this);
    this.onVideoLoad = this.onVideoLoad.bind(this);
    this.trackMoatVideoProgress = this.trackMoatVideoProgress.bind(this);
    this.loadHeartbeatCore = this.loadHeartbeatCore.bind(this);

    this.state = {
      videoTitle: '',
      // userIsActive: true,
      firstimp: false,
      adDataForMoat: null,
      calledMoatEventTrackerMarker: {}
    };
    this.videoContainerRef = React.createRef();
    this.MoatApiReference = null;

    // variable init
    this.adPosition = 0;
    this.lastKnownPlaybackPosition = 0;
    this.lastSystemClock = 0;
    this.mediaInfo = {};
    this.customVideoMetadata = {};

    // flags
    this.sessionStarted = false;
    this.playSent = false;
    this.adsPlaying = false;
  }

  componentDidMount() {
    if (scriptjs) {
      scriptjs(['https://z.moatads.com/jwplayerplugin0938452/moatplugin.js']);
    }

    this.loadHeartbeatCore();

    // Set up activity tracker, 5s = idle
    // if (ifvisible) {
    //   ifvisible.setIdleDuration(5);

    //   ifvisible.on('idle', () => {
    //     this.setState({
    //       userIsActive: false
    //     });
    //   });

    //   ifvisible.on('wakeup', () => {
    //     this.setState({
    //       userIsActive: true
    //     });
    //   });
    // }
  }

  componentWillUnmount() {
    if (canUseDOM) {
      if (window.moatjw) {
        window.moatjw.removeAll();
      }

      if (ifvisible) {
        ifvisible.off('idle');
        ifvisible.off('wakeup');
      }
    }
  }

  onVideoLoad(event) {
    this.setState({
      videoTitle: get(event, 'item.title')
    });
  }

  onReady() {
    // const { post } = this.props;
    // const playerid = get(post, 'playerScriptId');
    // const player = window.jwplayer(playerid);
    // const caption = player.getMute() ? 1 : 0;
    const { playerid } = this.props;
    const player = window.jwplayer(playerid);
    const caption = player.getMute() ? 1 : 0;
    // player.setCurrentCaptions(caption);

    this.player = player;

    player.setCurrentCaptions(caption);

    // Enable Adobe Heartbeat tracking
    this.setupAdobeHeartbeatTracking(this.player);

    player.on('playlistItem', info => {
      // console.log('[🧡]>>>> playlistItem', info.item);
      const { config } = this.props;

      let title;
      let mediaid;

      if (info.item.hasOwnProperty('title')) {
        title = get(info, 'item.title', 'unknown');
      }
      if (info.item.hasOwnProperty('mediaid')) {
        mediaid = get(info, 'item.mediaid', 'unknown');
      } else if (info.item.hasOwnProperty('file')) {
        mediaid = get(info, 'item.file', 'unknown');
      }

      // Set media info information
      this.mediaInfo = window.MediaHeartbeat.createMediaObject(
        title,
        String(mediaid),
        player.getDuration(),
        window.MediaHeartbeat.StreamType.VOD
      );

      // Set standard video metadata
      const standardVideoMetadata = {};
      standardVideoMetadata[
        window.MediaHeartbeat.VideoMetadataKeys.ASSET_ID
      ] = mediaid;
      standardVideoMetadata[window.MediaHeartbeat.VideoMetadataKeys.SHOW] =
        'Sample Show';
      standardVideoMetadata[window.MediaHeartbeat.VideoMetadataKeys.SEASON] =
        'Sample Season';
      standardVideoMetadata[window.MediaHeartbeat.VideoMetadataKeys.EPISODE] =
        'Sample Episode';

      this.mediaInfo.setValue(
        window.MediaHeartbeat.MediaObjectKey.StandardVideoMetadata,
        standardVideoMetadata
      );

      // Note that JWP Custom Parameters are also available in the metadata object and
      // can be sent to Adobe heartbeat. e.g. If not tracking custom parameters
      // then send 'null' to trackSessionStart
      //
      this.customVideoMetadata = {
        playerDimensions: `${player.getContainer().offsetWidth}x${
          player.getContainer().offsetHeight
        }`,
        abgroup: get(config, 'abgroup', 'null')
      };

      // Initialize play positions
      //
      this.lastKnownPlaybackPosition = 0;
      this.lastSystemClock = 0;
      this.playSent = false;
    });

    player.on('beforePlay', () => {
      /* console.log(
        '[🧡]>>>> beforePlay event, position: ',
        player.getPosition()
      ); */
      if (player.getPosition() === 0) {
        // console.log('[🧡]>>>> Session has started');
        if (!this.sessionStarted) {
          this.sessionStarted = true;

          this.mediaHeartbeat.trackSessionStart(
            this.mediaInfo,
            this.customVideoMetadata
          );
        }
      }

      if (player.getState() === 'paused') {
        // console.log('[🧡]>>>> beforePlay: Send #trackPlay()');
        this.mediaHeartbeat.trackPlay();
      }
    });

    player.on('firstFrame', () => {
      // console.log('[🧡]>>>> firstFrame');

      // If haven't sent the play event then send it.  Note that it's possible the
      // play vent was sent when the AdStart event was signaled
      if (!this.playSent) {
        // console.log('[🧡]>>>> firstFrame: Send #trackPlay');
        this.mediaHeartbeat.trackPlay();
        this.PlaySent = true;
      }
    });

    player.on('time', data => {
      const d = new Date();
      this.lastSystemClock = d.getTime();
      this.lastKnownPlaybackPosition = data.position;

      // custom code specific for this component
      const percentPlayed = Math.floor(data.position * 100 / data.duration);
      const marker = {};

      switch (percentPlayed) {
        case 1:
          if (!this.state.calledMoatEventTrackerMarker.AdVideoStart) {
            this.trackMoatVideoProgress('AdVideoStart', player, data);
            marker.AdVideoStart = true;
            this.setState({
              calledMoatEventTrackerMarker: marker
            });
          }
          break;
        case 25:
          if (!this.state.calledMoatEventTrackerMarker.AdVideoFirstQuartile) {
            this.trackMoatVideoProgress('AdVideoFirstQuartile', player, data);
            marker.AdVideoFirstQuartile = true;
            this.setState({
              calledMoatEventTrackerMarker: marker
            });
          }
          break;
        case 50:
          if (!this.state.calledMoatEventTrackerMarker.AdVideoMidpoint) {
            this.trackMoatVideoProgress('AdVideoMidpoint', player, data);
            marker.AdVideoMidpoint = true;
            this.setState({
              calledMoatEventTrackerMarker: marker
            });
          }
          break;
        case 75:
          if (!this.state.calledMoatEventTrackerMarker.AdVideoThirdQuartile) {
            this.trackMoatVideoProgress('AdVideoThirdQuartile', player, data);
            marker.AdVideoThirdQuartile = true;
            this.setState({
              calledMoatEventTrackerMarker: marker
            });
          }
          break;
        case 99:
          if (!this.state.calledMoatEventTrackerMarker.AdVideoComplete) {
            this.trackMoatVideoProgress('AdVideoComplete', player, data);
            marker.AdVideoComplete = true;
            this.setState({
              calledMoatEventTrackerMarker: marker
            });
          }
          break;
        default:
          break;
      }
    });

    player.on('adTime', data => {
      const d = new Date();
      this.lastSystemClock = d.getTime();
      this.lastKnownPlaybackPosition = data.position;
    });

    player.on('seek', () => {
      // console.log('[🧡]>>>> Send #trackEvent:SeekStart');
      this.mediaHeartbeat.trackEvent(window.MediaHeartbeat.Event.SeekStart);
    });

    player.on('seeked', () => {
      // console.log('[🧡]>>>> Send #trackEvent:SeekComplete');
      this.lastKnownPlaybackPosition = player.getPosition(); // Save last known position
      this.mediaHeartbeat.trackEvent(window.MediaHeartbeat.Event.SeekComplete);
    });

    // User paused the video
    player.on('pause', e => {
      // console.log('[🧡]>>>> send #trackPause');
      this.mediaHeartbeat.trackPause();

      // custom code specific for this component
      this.trackMoatVideoProgress('AdPaused', player, e);
    });

    // If the play event is fired and ads were playing,
    // then send the AdBreakComplete event.  There is
    // no ad playback end event
    //
    player.on('play', e => {
      // console.log('[🧡]>>>> play Event');
      if (this.adsPlaying) {
        // console.log('[🧡]>>>> play: Send #trackEvent:AdBreakComplete');
        this.mediaHeartbeat.trackEvent(
          window.MediaHeartbeat.Event.AdBreakComplete
        );
        this.adsPlaying = false;
      }

      // Custom code specific for this component
      this.trackMoatVideoProgress('AdPlaying', player, e);
    });

    player.on('complete', () => {
      // console.log('[🧡]>>>> complete');

      // If an ad was playing (POST-ROLL), send the AdBreakComplete
      if (this.adsPlaying) {
        // console.log('[🧡]>>>> complete: (POST-ROLL) Send #AdBreakComplete');
        this.mediaHeartbeat.trackEvent(
          window.MediaHeartbeat.Event.AdBreakComplete
        );
        this.adsPlaying = false;
      }

      // console.log('[🧡]>>>> Send #trackComplete');
      this.mediaHeartbeat.trackComplete();
      this.resetSession();

      // Force player stop if user determined to be inactive.
      // FOR NOW: Commenting out so video playlist autoplays through.
      // TODO: move this to a more useful place?
      // if (!this.state.userIsActive) {
      //   player.stop();
      // }

      // custom code specific for this component
      this.setState({
        firstimp: false
      });
    });

    // Only send the buffer event if the session has been started
    // We don't send one just because the player loaded and pre-buffered
    player.on('buffer', () => {
      if (this.sessionStarted) {
        // console.log('[🧡]>>>> Send #trackEvent:BufferStart');
        this.mediaHeartbeat.trackEvent(window.MediaHeartbeat.Event.BufferStart);
      }
    });
    player.on('bufferFull', () => {
      if (this.sessionStarted) {
        // console.log('[🧡]>>>> Send #trackEvent:BufferComplete');
        this.mediaHeartbeat.trackEvent(
          window.MediaHeartbeat.Event.BufferComplete
        );
      }
    });

    player.on('error', () => {
      // console.log('[🧡]>>>> (error) Send #trackError');

      // // Send all the error data as a string
      // this.mediaHeartbeat.trackError(createErrorString(data));

      // // error means the player stopped so reset the session
      this.resetSession();
    });

    player.on('setupError', () => {
      // console.log('[🧡]>>>> eventHandler: (setupError) Send #trackError');
      this.resetSession();
    });

    player.on('adImpression', data => {
      // console.log('[🧡]>>>> adImpression', data);

      const adDuration = get(data, 'ima.ad.g.duration', 0);
      const adTitle = get(data, 'adtitle', 'unknown-title');
      const adWrapperCreativeId = get(
        data,
        'ima.ad.g.adWrapperCreativeIds[0]',
        'unknown-wrapper-creative-id'
      );
      const adWrapperId = get(
        data,
        'ima.ad.g.adWrapperIds[0]',
        'unknown-wrapper-id'
      );
      const adCreativeId = get(
        data,
        'ima.ad.g.creativeId',
        'unknown-creative-id'
      );
      const adName = `${adTitle} | ${adWrapperCreativeId} | ${adWrapperId} | ${adCreativeId}`;

      // Start the adBreak if needed
      this.adStartBreak(
        adName,
        this.adPosition,
        this.lastKnownPlaybackPosition
      );

      // Create an adObject and custom metadata to track the ad
      const adObject = window.MediaHeartbeat.createAdObject(
        adName,
        data.id,
        this.adPosition,
        adDuration
      );
      const adCustomMetadata = {
        tag: data.tag,
        client: data.client
      };

      // Send the AdStart event
      // console.log('[🧡]>>>> adImpression: Send #trackEvent:AdStart', adObject);
      this.mediaHeartbeat.trackEvent(
        window.MediaHeartbeat.Event.AdStart,
        adObject,
        adCustomMetadata
      );

      // Note: The documentation says that after the first ad in a Pre-roll
      // starts to play, the 'trackPlay' event should be sent.  But, it seems,
      // in practice, this does not work correctly.  The adStart event that is sent
      // above in the adImpression handler, automatically kicks off the trackPlay
      // event.  Thus, just set the gPlaySent flag to true, so it is not sent again
      //
      if (!this.playSent) {
        this.playSent = true;
        // console.log('[🧡]>>>> adImpression: Sent #trackPlay');
        this.mediaHeartbeat.trackPlay();
      }
      // Set the flag that an Ad is playing
      //
      this.adsPlaying = true;

      // Track with Moat
      // this.trackMoat(player, data);
    });

    player.on('adPlay', () => {
      // console.log('[🧡]>>>> adPlay');
      if (!this.playSent) {
        // console.log('[🧡]>>>> adPlay: Send #trackPlay');
        this.mediaHeartbeat.trackPlay();
        this.playSent = true;
      }
    });

    player.on('adStarted', () => {
      // console.log('[🧡]>>>> adStarted. do nothing.');
    });

    player.on('adSkipped', () => {
      // console.log('[🧡]>>>> adSkipped: Send #trackEvent:AdSkip');
      this.mediaHeartbeat.trackEvent(window.MediaHeartbeat.Event.AdSkip);

      // Set the flag to false so the AdBreakComplete is not sent
      // unless a new ad starts playing
      this.adsPlaying = false;
    });

    player.on('adComplete', () => {
      // console.log('[🧡]>>>> adComplete: Send #trackEvent:AdComplete');
      this.mediaHeartbeat.trackEvent(window.MediaHeartbeat.Event.AdComplete);
    });

    player.on('adBreakEnd', () => {
      // console.log('[🧡]>>>> eventHandler: adBreakEnd');

      // If an ad was playing send the AdBreakComplete
      //
      if (this.adsPlaying) {
        // console.log('[🧡]>>>> adBreakEnd: Send #trackEvent:AdBreakComplete');
        this.mediaHeartbeat.trackEvent(
          window.MediaHeartbeat.Event.AdBreakComplete
        );
        this.adsPlaying = false;
      }
    });

    player.on('remove', () => {
      // Close the session if it's still in progress
      if (this.sessionStarted) {
        // console.log('[🧡]>>>> remove: session in progress. stop it');
        this.resetSession();
      } else {
        // console.log('[🧡]>>>> remove: session not in progress. do nothing.');
      }
    });

    player.on('adRequest', ad => {
      const adDataDFP = get(ad, 'ima.ad.g');
      const { adId, creativeId, title } = adDataDFP;

      const adDataForMoat = {
        level1:
          get(adDataDFP, 'advertiserName', `advertiser for unit: ${title}`) ||
          `advertiser for unit: ${title}`,
        level2: title,
        level3: adId,
        level4: creativeId,
        slicer1: 'fastcompany',
        slicer2: creativeId
      };

      this.setState({
        adDataForMoat,
        calledMoatEventTrackerMarker: {}
      });
      this.MoatApiReference = null;
    });

    this.setMoatTracking(player);
  }

  // onZeady() {
  //   const { playerid } = this.props;
  //   const player = window.jwplayer(playerid);

  //   const caption = player.getMute() ? 1 : 0;
  //   player.setCurrentCaptions(caption);

  //   player.on('complete', () => {
  //     this.setState({
  //       firstimp: false
  //     });
  //     if (!this.state.userIsActive) {
  //       player.stop();
  //     }
  //   });

  //   player.onTime(e => {
  //     // over 10 sec, send tracking to JW
  //     const percentPlayed = Math.floor(e.position * 100 / e.duration);
  //     const marker = {};

  //     switch (percentPlayed) {
  //       case 1:
  //         if (!this.state.calledMoatEventTrackerMarker.AdVideoStart) {
  //           this.trackMoatVideoProgress('AdVideoStart', player, e);
  //           marker.AdVideoStart = true;
  //           this.setState({
  //             calledMoatEventTrackerMarker: marker
  //           });
  //         }
  //         break;
  //       case 25:
  //         if (!this.state.calledMoatEventTrackerMarker.AdVideoFirstQuartile) {
  //           this.trackMoatVideoProgress('AdVideoFirstQuartile', player, e);
  //           marker.AdVideoFirstQuartile = true;
  //           this.setState({
  //             calledMoatEventTrackerMarker: marker
  //           });
  //         }
  //         break;
  //       case 50:
  //         if (!this.state.calledMoatEventTrackerMarker.AdVideoMidpoint) {
  //           this.trackMoatVideoProgress('AdVideoMidpoint', player, e);
  //           marker.AdVideoMidpoint = true;
  //           this.setState({
  //             calledMoatEventTrackerMarker: marker
  //           });
  //         }
  //         break;
  //       case 75:
  //         if (!this.state.calledMoatEventTrackerMarker.AdVideoThirdQuartile) {
  //           this.trackMoatVideoProgress('AdVideoThirdQuartile', player, e);
  //           marker.AdVideoThirdQuartile = true;
  //           this.setState({
  //             calledMoatEventTrackerMarker: marker
  //           });
  //         }
  //         break;
  //       case 99:
  //         if (!this.state.calledMoatEventTrackerMarker.AdVideoComplete) {
  //           this.trackMoatVideoProgress('AdVideoComplete', player, e);
  //           marker.AdVideoComplete = true;
  //           this.setState({
  //             calledMoatEventTrackerMarker: marker
  //           });
  //         }
  //         break;
  //       default:
  //         break;
  //     }
  //   });

  //   player.on('play', e => {
  //     this.trackMoatVideoProgress('AdPlaying', player, e);
  //   });

  //   player.on('pause', e => {
  //     this.trackMoatVideoProgress('AdPaused', player, e);
  //   });

  //   player.on('adRequest', ad => {
  //     const adDataDFP = get(ad, 'ima.ad.g');
  //     const { adId, creativeId, title } = adDataDFP;

  //     const adDataForMoat = {
  //       level1:
  //         get(adDataDFP, 'advertiserName', `advertiser for unit: ${title}`) ||
  //         `advertiser for unit: ${title}`,
  //       level2: title,
  //       level3: adId,
  //       level4: creativeId,
  //       slicer1: 'fastcompany',
  //       slicer2: creativeId
  //     };

  //     this.setState({
  //       adDataForMoat,
  //       calledMoatEventTrackerMarker: {}
  //     });
  //     this.MoatApiReference = null;
  //   });
  //   this.setMoatTracking(player);
  // }

  setMoatTracking(player) {
    if (canUseDOM) {
      if (window.moatjw) {
        player.on('adImpression', event => {
          window.moatjw.add({
            partnerCode: 'mansuetojwint127635890115',
            player,
            adImpressionEvent: event
          });
        });
      }
    }
  }

  setupAdobeHeartbeatTracking(player) {
    const { playerid } = this.props;

    // Implement the `MediaHeartbeatDelegate` protocol
    const mediaDelegate = new window.MediaHeartbeatDelegate();

    mediaDelegate.getCurrentPlaybackTime = () => player.getPosition();
    mediaDelegate.getQoSObject = () =>
      window.MediaHeartbeat.createQoSObject(player.getPlaybackRate(), 0, 60, 0); // bitrate, startup time, fps, dropped frames

    // Create a `MediaHeartbeatConfig` instance
    const mediaConfig = new window.MediaHeartbeatConfig();
    mediaConfig.trackingServer = 'grunerandjahr.hb.omtrdc.net';
    mediaConfig.playerName = `${playerid} | Base FC Player - Siderail Video`;
    mediaConfig.channel = 'Fast Company';
    mediaConfig.debugLogging = false;
    mediaConfig.ssl = true;
    mediaConfig.ovp = 'unknown';

    this.mediaHeartbeat = new window.MediaHeartbeat(
      mediaDelegate,
      mediaConfig,
      window.s
    );
  }

  resetSession() {
    // console.log('[🧡]>>>> Send #trackSessionEnd');
    this.mediaHeartbeat.trackSessionEnd();
    this.sessionStarted = false; // Will need to reinitialize for next video
    this.playSent = false;
  }

  adStartBreak(name, pos, start) {
    if (!this.adsPlaying) {
      /* console.log(
        '[🧡]>>>> adStartBreak: Send #trackEvent:AdStartBreak',
        name,
        pos,
        start
      ); */
      const adBreakInfo = window.MediaHeartbeat.createAdBreakObject(
        name,
        pos,
        start
      );
      this.mediaHeartbeat.trackEvent(
        window.MediaHeartbeat.Event.AdBreakStart,
        adBreakInfo
      );
      this.adsPlaying = true;
      this.adPosition = 0;
    } else {
      this.adPosition = this.adPosition + 1; // Just increase the adPosition value
      /* console.log(
        `[🧡]>>>> adStartBreak: Ad in position ${this.adPosition} starting`
      ); */
    }
  }

  loadHeartbeatCore() {
    const heartbeatCoreLibrary = document.createElement('script');
    if (canUseDOM && typeof window.ADB === 'undefined') {
      // Load the Adobe Heartbeat Core Plugin for video tracking
      heartbeatCoreLibrary.src =
        '//www.incimages.com/dev/video/launch/JWVideoHeartbeat.min.js';
      document.body.appendChild(heartbeatCoreLibrary);
      heartbeatCoreLibrary.onload = () => {
        // const heartbeatBridge = document.createElement('script');
        // heartbeatBridge.src =
        //   '//www.incimages.com/dev/video/launch/HeartbeatBridge.js';
        // document.body.appendChild(heartbeatBridge);
        // Setup local references to Adobe `MediaHeartbeat` classes
        window.MediaHeartbeat = window.ADB.va.MediaHeartbeat; // eslint-disable-line
        window.MediaHeartbeatConfig = window.ADB.va.MediaHeartbeatConfig; // eslint-disable-line
        window.MediaHeartbeatDelegate = window.ADB.va.MediaHeartbeatDelegate; // eslint-disable-line
      };
    }
  }

  trackMoatVideoProgress(eventType, player, e) {
    const MoatTrackingPartnerCode = 'mansuetojwcontent613342534978';

    if (!this.MoatApiReference) {
      this.MoatApiReference = window.initMoatTracking(
        this.videoContainerRef.current,
        this.state.adDataForMoat,
        e.duration,
        MoatTrackingPartnerCode,
        null
      );
    }

    this.MoatApiReference.dispatchEvent({
      type: eventType,
      adVolume: player.getMute() ? 0 : (player.getVolume() / 100).toFixed(1)
    });
  }

  generatePreRoll() {
    const { data, type, pos, readTime } = this.props;
    const customparams = get(this.props, 'customparams', false);

    if (!Cookies.get('dailycookie') && !this.state.alreadySawFirstImpression) {
      this.setState({
        firstimp: true,
        alreadySawFirstImpression: true
      });
    }

    return new AdTagGenerator(
      get(data, 'title'),
      type,
      'preroll_rightrail',
      readTime,
      pos,
      this.state.firstimp,
      customparams
    ).adTag;
  }

  render() {
    const { playerid, playlistId } = this.props;

    return (
      <div className="siderail-video-module">
        <Slug slugName={this.props.slugName} className="column" />
        <div
          className="siderail-video-module__player-container"
          ref={this.videoContainerRef}
        >
          <Video
            playerId={playerid}
            customProps={{
              sharing: {
                link: 'https://www.fastcompany.com/videos'
              }
            }}
            playerScript={`https://content.jwplatform.com/libraries/${playerid}.js`}
            playlist={`//content.jwplatform.com/feeds/${playlistId}.json`}
            generatePrerollUrl={this.generatePreRoll}
            onReady={this.onReady}
            onVideoLoad={this.onVideoLoad}
            onError={event => {
              log.error(
                'Siderail ReactJW Video Player Error',
                get(event, 'message')
              );
            }}
            onSetupError={event => {
              log.error(
                'Siderail ReactJW Video Player Error',
                get(event, 'message')
              );
            }}
            playInView={true}
            isMuted={true}
            isAutoPlay={false}
            playInViewPercentage={100}
            aspectRatio="16:9"
            useMultiplePlayerScripts={true}
          />
        </div>
        <h3 className="card__title card__title--small siderail-video-module__player-title-slug">
          {this.state.videoTitle}
        </h3>
      </div>
    );
  }
}

VideoReactJW.defaultProps = {
  data: {},
  config: {},
  slugName: 'Featured Video',
  readTime: null
};

VideoReactJW.propTypes = {
  data: PropTypes.shape({}),
  playerid: PropTypes.string.isRequired,
  playlistId: PropTypes.string.isRequired,
  slugName: PropTypes.string,
  type: PropTypes.string.isRequired,
  pos: PropTypes.string.isRequired,
  readTime: PropTypes.string,
  config: PropTypes.shape({})
};
